const variable = (env: string) => {
  switch(env){
    case 'production':
      return {
        clientId: "778b8480-8563-4155-a43c-a73cc35aa751",
        authority: "https://login.microsoftonline.com/wk12.org",
        redirectUri: "https://sis.wk12.org"
      }
    case 'beta':
      return {
        clientId: "e92faae2-e072-4088-9f5c-e96498a8e105",
        authority: "https://login.microsoftonline.com/wk12.org",
        redirectUri: "https://beta.sis.wk12.org"
      }
    default:
      return {
        clientId: "1c3bfe8e-a631-49fa-9e4c-7b93ebff438a",
        authority: "https://login.microsoftonline.com/wk12.org",
        redirectUri: "http://localhost:3000"
      }
  }
}

// APP SERVICES CONFIG
export const msalConfig = {
  auth: variable(process.env.REACT_APP_AUTH_CONFIG || ''),
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  }
}

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
  scopes: ["User.Read"]
}

// Add the endpoints here for Microsoft Graph API services you'd like to use.
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
}